var isFirstSuffix = function (restOf10, restOf100) {
    return restOf10 === 1 && restOf100 !== 11;
};
var isSecondSuffix = function (restOf10, restOf100) {
    return restOf10 === 2 && restOf100 !== 12;
};
var isThirdSuffix = function (restOf10, restOf100) {
    return restOf10 === 3 && restOf100 !== 13;
};
var getSuffix = function (restOf10, restOf100) {
    if (isFirstSuffix(restOf10, restOf100)) {
        return 'st';
    }
    if (isSecondSuffix(restOf10, restOf100)) {
        return 'nd';
    }
    if (isThirdSuffix(restOf10, restOf100)) {
        return 'rd';
    }
    return 'th';
};
/**
 * Transform number to ordinal representation
 *
 * ### Example (es module)
 * ```js
 * console.log(ordinalSuffixOf(1)) // => 1st
 * console.log(ordinalSuffixOf(2)) // => 2nd
 * console.log(ordinalSuffixOf(3)) // => 3rd
 * console.log(ordinalSuffixOf(25)) // => 25th
 * console.log(ordinalSuffixOf(1001)) // => 1001st
 * ```
 */
export var ordinalSuffixOf = function (num) {
    var restOf10 = num % 10;
    var restOf100 = num % 100;
    return num + getSuffix(restOf10, restOf100);
};
/**
 * Transform number to into currency format
 */
export var currencyFormat = function (num, currency, showSign) {
    if (currency === void 0) { currency = '$'; }
    if (showSign === void 0) { showSign = false; }
    var million = Math.pow(10, 6);
    var thousand = Math.pow(10, 3);
    var sign = Math.sign(num);
    var signSymbol = showSign && sign === -1 ? '-' : '';
    var abs = Math.abs(num);
    var isNumberThousand = abs < million;
    var isNumberMillion = abs >= million;
    if (isNumberThousand) {
        return signSymbol + currency + Math.round(abs / thousand) + 'k';
    }
    else if (isNumberMillion) {
        return signSymbol + currency + Math.round(abs / million) + 'm';
    }
    else {
        return signSymbol + currency + Math.round(abs / million);
    }
};
//# sourceMappingURL=data:application/json;base64,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